export default __webpack_public_path__ + "static/media/aiObjectActive.ee791f17.svg";